export const AUTH_LOGIN = 'authLogin'
export const AUTH_CHECK = 'authCheck'
export const BASE_QUEUE = 'baseQueue'
export const BASE_APP_DATA = 'baseAppData'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js